import { VariantPurchaseInfo } from '../productForm/ProductForm'

import getPreorder from './getPreorder'
import { CTA_TYPE } from './productCTAConstants'

interface ProductCTAType {
  selectedVariantPurchaseInfo?: VariantPurchaseInfo
}

function useProductCTAType({ selectedVariantPurchaseInfo }: ProductCTAType) {
  const isPreorder = selectedVariantPurchaseInfo?.isPreorder
  const isNewPreorderItem = selectedVariantPurchaseInfo?.isNewPreorderProduct
  const { showPreorder } = getPreorder(isPreorder, isNewPreorderItem)
  const preOrderShippingDate = selectedVariantPurchaseInfo?.preOrderShippingDate

  if (selectedVariantPurchaseInfo?.showWaitList) {
    return CTA_TYPE.WAITLIST
  }

  if (isPreorder) {
    const isFuturePreOrderShippingDate = preOrderShippingDate ? Date.parse(preOrderShippingDate) >= Date.now() : false

    if (showPreorder && isFuturePreOrderShippingDate) {
      return CTA_TYPE.PREORDER
    }
    return CTA_TYPE.WAITLIST
  }

  return CTA_TYPE.ADD_TO_CART
}

export default useProductCTAType
